import {
  gaCodeFromProductTypeId,
  typeCodeFromProductTypeId
} from '../productMappings';

const WORK_PAGE_CATEGORY = 'Work Page';
const SHOP_PAGE_CATEGORY = 'Shop Page';
const ARTIST_SHOP_PAGE_CATEGORY = 'Artist Shop Page';
const EXPLORE_PAGE_CATEGORY = 'Explore Page';
const EXPLORE_FOLLOWING_PAGE_CATEGORY = 'Explore Following Page';
const HOME_PAGE_CATEGORY = 'Home Page';
const SEARCH_CATEGORY = 'Search';
const SUSCRIBE_BANNER = 'subscribe-banner';
const SUSCRIBE_SHOWED = 'subscribe-showed';
const SUSCRIBE_FAILED = 'subscribe-failed';
const SUSCRIBE_SUCCEED = 'subscribe-succeed';
const SUSCRIBE_DISMISSED = 'subscribe-dismissed';
export const ADD_TO_CART_ACTION = 'product-add-to-cart';
const PRODUCT_VIEW_ACTION = 'product-view';
const SEARCH_BOX_FOCUS = 'site-search-query-focus';
const SEARCH_BOX_INPUT = 'site-search-query-input';
const TYPEAHEAD_SHOWN = 'typeahead-shown';
const TYPEAHEAD_SELECTED = 'typeahead-selected';
const RECOMMEND_CAROUSEL_RESULTS_SHOWED = 'results-showed';
const RECOMMEND_CAROUSEL_NO_RESULTS_SHOWED = 'no-results-showed';
const RECOMMEND_CAROUSEL_END_REACHED = 'end-reached';
const RECOMMEND_CAROUSEL_INITIAL_RESULTS_FETCH_ERRORED =
  'initial-results-fetch-errored';
const RECOMMEND_CAROUSEL_FURTHER_RESULTS_FETCH_ERRORED =
  'further-results-fetch-errored';
const RECOMMEND_CAROUSEL_ITEM_CLICKED = 'item-clicked';
const RECOMMEND_CAROUSEL_LEFT_NAVIGATED = 'left-navigated';
const RECOMMEND_CAROUSEL_RIGHT_NAVIGATED = 'right-navigated';
const RECOMMEND_CAROUSEL_FURTHER_RESULTS_FETCH_SUCCEEDED =
  'further-results-fetch-succeded';
const SEARCH_SUGGESTIONS_ITEM_CLICKED = 'search-suggestions-item-clicked';
const SEARCH_SUGGESTIONS_SHOWED = 'search-suggestions-showed';
const SEARCH_SUGGESTIONS_SWIPED = 'search-suggestions-swiped';
const SEARCH_SUGGESTIONS_LEFT_CLICKED = 'search-suggestions-left-clicked';
const SEARCH_SUGGESTIONS_RIGHT_CLICKED = 'search-suggestions-right-clicked';
const FAVOURITING_CATEGORY = 'Favouriting';
const FOLLOWING_CATEGORY = 'Following';
const FAVOURITE_ACTION = 'favourite';
const UNFAVOURITE_ACTION = 'unfavourite';
const LOADED_MORE_ACTION = 'load-more';
const END_OF_RECOMMENDATIONS_ACTION = 'end-of-recommendations';
const END_OF_FOLLOW_FEED = 'end-of-feed';
export const FOLLOW_ACTION = 'follow';
export const UNFOLLOW_ACTION = 'unfollow';
const FAVOURITE_ON_EXPLORE_FEED = 'explore-feed';
export const EXPLORE_FEED_LABEL = 'explore-feed';
export const EXPLORE_FOLLOWING_LABEL = 'explore-following';
export const PRODUCT_RECOMMENDATIONS_SOURCE = 'explore-product-recommendations';
export const TOPIC_PRODUCT_RECOMMENDATIONS_SOURCE =
  'explore-topic-product-recommendations';
export const EXPLORE_FEED_PREVIEW_SOURCE = 'explore-feed-preview';
export const RECENTLY_VIEWED_LABEL = 'recently-viewed';
export const PRODUCT_RECOMMENDATIONS_LABEL = 'product-recommendations';
export const TOPIC_PRODUCT_RECOMMENDATIONS_LABEL =
  'topic-product-recommendations';
export const EXPLORE_WORK_DETAILS_LABEL = 'explore-work-details';
export const EXPLORE_MORE_LIKE_THIS_LABEL = 'explore-more-like-this';
export const EXPLORE_SHOP_AVAILABLE_PRODUCTS =
  'explore-shop-available-products';
export const IMPRESSION_CATEGORY = 'Impression';
export const CLICK_THROUGH_ACTION = 'click-through';
export const RECOMMENDED_WORK_LABEL = 'homepage-recommended-work';
const COMPONENT_SHOWED = 'component-showed';
const COMPONENT_SHOWED_LOADING = 'component-showed-loading';
const HOME_BANNER_BUTTON_INTERACTED = 'home-banner-button-clicked';
const HOME_BANNER_LABEL = 'home-banner';

const productCodeLabel = productCode => `product:${productCode}`;

const componentShowedInPage = pageCategory => (componentName, loading) => ({
  category: pageCategory,
  action: loading ? COMPONENT_SHOWED_LOADING : COMPONENT_SHOWED,
  label: componentName,
  nonInteraction: true
});

export const analyticsPayload = {
  favorite: ({ newState, workId, rank, source }) => {
    const label = Number.isInteger(rank)
      ? `${source || FAVOURITE_ON_EXPLORE_FEED}:${rank}`
      : `${source || FAVOURITE_ON_EXPLORE_FEED}`;

    const workIdInt = parseInt(workId, 10);
    const value = Number.isInteger(workIdInt) ? workIdInt : undefined;

    return {
      category: FAVOURITING_CATEGORY,
      action: newState === true ? FAVOURITE_ACTION : UNFAVOURITE_ACTION,
      label,
      value
    };
  },
  follow: (action, label, value) => ({
    category: FOLLOWING_CATEGORY,
    action: `${action}`,
    label: `${label}`,
    value
  }),
  clickThrough: (label, workId, rank) => ({
    category: IMPRESSION_CATEGORY,
    action: CLICK_THROUGH_ACTION,
    label: `${label}:${rank}`,
    value: parseInt(workId, 10)
  }),
  impression: (label, workId, rank) => ({
    id: workId,
    list: label,
    position: rank
  }),
  impressions: () => ({
    category: IMPRESSION_CATEGORY,
    action: 'Load',
    label: 'explore',
    nonInteraction: true
  }),
  loadedMore: (from, to, canSize) => ({
    category: EXPLORE_PAGE_CATEGORY,
    action: LOADED_MORE_ACTION,
    label: `${from}:${to}/${canSize}`
  }),
  endOfRecommendations: (from, to, canSize) => ({
    category: EXPLORE_PAGE_CATEGORY,
    action: END_OF_RECOMMENDATIONS_ACTION,
    label: `${from}:${to}/${canSize}`
  }),
  followFeedLoadMore: page => ({
    category: EXPLORE_FOLLOWING_PAGE_CATEGORY,
    action: LOADED_MORE_ACTION,
    label: `page:${page}`
  }),
  endOfFollowFeed: page => ({
    category: EXPLORE_FOLLOWING_PAGE_CATEGORY,
    action: END_OF_FOLLOW_FEED,
    label: `page:${page}`
  }),
  addToCart: (productTypeId, priceAmount) => ({
    category: WORK_PAGE_CATEGORY,
    action: ADD_TO_CART_ACTION,
    label: productCodeLabel(gaCodeFromProductTypeId(productTypeId)),
    value: Math.round(priceAmount * 100)
  }),
  productView: (productTypeId, priceAmount) => ({
    category: WORK_PAGE_CATEGORY,
    action: PRODUCT_VIEW_ACTION,
    label: productCodeLabel(gaCodeFromProductTypeId(productTypeId)),
    value: Math.round(priceAmount * 100)
  }),
  workPageView: label => ({
    category: WORK_PAGE_CATEGORY,
    action: CLICK_THROUGH_ACTION,
    label,
    transport: 'beacon'
  }),
  artistShopPageView: label => ({
    category: ARTIST_SHOP_PAGE_CATEGORY,
    action: CLICK_THROUGH_ACTION,
    label,
    transport: 'beacon'
  }),
  enhancedEcommerceProduct: (work, productTypeId, priceAmount, quantity) => ({
    id: `${work.id}-${gaCodeFromProductTypeId(productTypeId)}`,
    name: `${work.id} ${work.title}`,
    category: typeCodeFromProductTypeId(productTypeId),
    price: priceAmount,
    quantity
  }),
  subscribeFailed: () => ({
    category: SHOP_PAGE_CATEGORY,
    action: SUSCRIBE_FAILED,
    label: SUSCRIBE_BANNER
  }),
  subscribeSucceed: () => ({
    category: SHOP_PAGE_CATEGORY,
    action: SUSCRIBE_SUCCEED,
    label: SUSCRIBE_BANNER
  }),
  subscribeDismissed: () => ({
    category: SHOP_PAGE_CATEGORY,
    action: SUSCRIBE_DISMISSED,
    label: SUSCRIBE_BANNER
  }),
  subscribeShowed: () => ({
    category: SHOP_PAGE_CATEGORY,
    action: SUSCRIBE_SHOWED,
    label: SUSCRIBE_BANNER
  }),
  searchBoxFocus: () => ({
    category: SEARCH_CATEGORY,
    action: SEARCH_BOX_FOCUS
  }),
  searchBoxInput: () => ({
    category: SEARCH_CATEGORY,
    action: SEARCH_BOX_INPUT
  }),
  typeaheadShown: () => ({
    category: SEARCH_CATEGORY,
    action: TYPEAHEAD_SHOWN
  }),
  typeaheadSelected: (selected, textInBox) => ({
    category: SEARCH_CATEGORY,
    action: TYPEAHEAD_SELECTED,
    label: `${selected}:${textInBox}`
  }),
  recommendCarouselResultsShowed: () => ({
    category: SEARCH_CATEGORY,
    action: RECOMMEND_CAROUSEL_RESULTS_SHOWED,
    label: 'Recommend carousel'
  }),
  recommendCarouselNoResultsShowed: () => ({
    category: SEARCH_CATEGORY,
    action: RECOMMEND_CAROUSEL_NO_RESULTS_SHOWED,
    label: 'Recommend carousel'
  }),
  recommendCarouselEndReached: () => ({
    category: SEARCH_CATEGORY,
    action: RECOMMEND_CAROUSEL_END_REACHED,
    label: 'Recommend carousel'
  }),
  recommendCarouselInitialResultsFetchErrored: () => ({
    category: SEARCH_CATEGORY,
    action: RECOMMEND_CAROUSEL_INITIAL_RESULTS_FETCH_ERRORED,
    label: 'Recommend carousel'
  }),
  recommendCarouselFurtherResultsFetchErrored: () => ({
    category: SEARCH_CATEGORY,
    action: RECOMMEND_CAROUSEL_FURTHER_RESULTS_FETCH_ERRORED,
    label: 'Recommend carousel'
  }),
  recommendCarouselItemClicked: () => ({
    category: SEARCH_CATEGORY,
    action: RECOMMEND_CAROUSEL_ITEM_CLICKED,
    label: 'Recommend carousel'
  }),
  recommendCarouselLeftNavigated: () => ({
    category: SEARCH_CATEGORY,
    action: RECOMMEND_CAROUSEL_LEFT_NAVIGATED,
    label: 'Recommend carousel'
  }),
  recommendCarouselRightNavigated: () => ({
    category: SEARCH_CATEGORY,
    action: RECOMMEND_CAROUSEL_RIGHT_NAVIGATED,
    label: 'Recommend carousel'
  }),
  recommendCarouselFurtherResultsFetchSucceded: () => ({
    category: SEARCH_CATEGORY,
    action: RECOMMEND_CAROUSEL_FURTHER_RESULTS_FETCH_SUCCEEDED,
    label: 'Recommend carousel'
  }),
  searchSuggestionsItemClicked: index => ({
    category: SEARCH_CATEGORY,
    action: SEARCH_SUGGESTIONS_ITEM_CLICKED,
    label: 'cp02-suggestions',
    value: index
  }),
  searchSuggestionsShowed: numberOfSuggestions => ({
    category: SEARCH_CATEGORY,
    action: SEARCH_SUGGESTIONS_SHOWED,
    label: 'cp02-suggestions',
    value: numberOfSuggestions
  }),
  searchSuggestionsSwiped: () => ({
    category: SEARCH_CATEGORY,
    action: SEARCH_SUGGESTIONS_SWIPED,
    label: 'cp02-suggestions'
  }),
  searchSuggestionsLeftClicked: () => ({
    category: SEARCH_CATEGORY,
    action: SEARCH_SUGGESTIONS_LEFT_CLICKED,
    label: 'cp02-suggestions'
  }),
  searchSuggestionsRightClicked: () => ({
    category: SEARCH_CATEGORY,
    action: SEARCH_SUGGESTIONS_RIGHT_CLICKED,
    label: 'cp02-suggestions'
  }),
  shopSearchTopFilterOpen: () => ({
    category: SEARCH_CATEGORY,
    action: 'shop-search-top-filter-open',
    label: 'ps16-top-filter'
  }),
  shopSearchTopFilterLinkClick: () => ({
    category: SEARCH_CATEGORY,
    action: 'shop-search-top-filter-link-click',
    label: 'ps16-top-filter'
  }),
  shopSearchTopFilterClose: () => ({
    category: SEARCH_CATEGORY,
    action: 'shop-search-top-filter-close',
    label: 'ps16-top-filter'
  }),
  productRecommendationsCarouselLoaded: count => ({
    category: EXPLORE_PAGE_CATEGORY,
    action: 'carousel-loaded',
    label: PRODUCT_RECOMMENDATIONS_LABEL,
    value: count,
    nonInteraction: true
  }),
  recentViewCarouselLoaded: count => ({
    category: EXPLORE_PAGE_CATEGORY,
    action: 'recently-viewed-loaded',
    label: RECENTLY_VIEWED_LABEL,
    value: count,
    nonInteraction: true
  }),
  recentViewCarouselClick: label => ({
    category: EXPLORE_PAGE_CATEGORY,
    action: 'recently-viewed-clicked',
    label
  }),
  componentShowedInHomePage: componentShowedInPage(HOME_PAGE_CATEGORY),
  componentShowedInExplorePage: componentShowedInPage(EXPLORE_PAGE_CATEGORY),
  heroBannerCTAClicked: () => ({
    category: HOME_PAGE_CATEGORY,
    action: HOME_BANNER_BUTTON_INTERACTED,
    label: HOME_BANNER_LABEL
  })
};

export const callbackWithTimeout = (callback, timeout = 250) => {
  let called = false;

  const fn = (calledByTimeout = false) => {
    if (!called) {
      called = true;
      callback(calledByTimeout);
    }
  };

  setTimeout(() => fn(true), timeout);

  return fn;
};

export default analyticsPayload;
